import type { FileId } from '../../../shared/domain/files/types.no-deps'
import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/filesS3Url' }

export interface S3FileUrl {
    [key: string]: string
}

type Params = never
type Body = { fileIds: FileId[] }
type Query = { thumbnail?: boolean }
type Output = { fileUrls: S3FileUrl }

export type GetFilesS3urlEndpoint = Endpoint<Params, Body, Query, Output>

export const getFilesS3UrlRequest = (request: Request, args: RequestArgs<GetFilesS3urlEndpoint>) =>
    request<GetFilesS3urlEndpoint>(route, args)
